module.exports = __webpack_public_path__ + "static/img/6291_phase_function_Paper_PointsHejduk_Prediction.0587997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6291_phase_function_Paper_PointsHejduk_Prediction.png
// module id = q78d
// module chunks = 0